// src/components/Blocks/Listing/DownloadListingSchema.js

export const DownloadListingSchema = ({ schema, formData, intl }) => {
  // Keep the default listing schema, no additional fields needed
  return schema;
};
